import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useLanguage, languageNames } from "./LanguageProvider";
import { detectBrowserLang } from "./LanguageProvider";
import { X } from "lucide-react";

const bannerText = {
  nl: "Deze pagina is ook beschikbaar in het",
  en: "This page is also available in",
  fr: "Cette page est aussi disponible en",
  de: "Diese Seite ist auch verfügbar auf",
};

export default function LanguageBanner() {
  const { language, localizedPath } = useLanguage();
  const [dismissed, setDismissed] = useState(true);

  useEffect(() => {
    if (sessionStorage.getItem("cf-lang-banner-dismissed")) return;
    const browser = detectBrowserLang();
    if (browser !== language) setDismissed(false);
  }, [language]);

  if (dismissed) return null;

  const browserLang = detectBrowserLang();
  const label = languageNames[browserLang]?.name || browserLang;

  const dismiss = () => {
    setDismissed(true);
    sessionStorage.setItem("cf-lang-banner-dismissed", "1");
  };

  return (
    <div className="bg-[#4DD0E1]/10 border-b border-[#4DD0E1]/20 px-4 py-2 text-center text-sm" data-testid="language-banner">
      <span className="text-[#A1A1AA]">{bannerText[language] || bannerText.nl} </span>
      <Link
        to={localizedPath(browserLang)}
        className="text-[#4DD0E1] font-bold hover:underline"
        onClick={dismiss}
      >
        {label}
      </Link>
      <button onClick={dismiss} className="ml-3 text-[#A1A1AA] hover:text-white" aria-label="Sluiten">
        <X size={14} className="inline" />
      </button>
    </div>
  );
}
